import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import Tooltip from '@material-ui/core/Tooltip';
import RaiseHandIcon from '../../../icons/RaiseHandIcon';
import { LocalDataTrackPublication } from 'twilio-video';
import { useAppState } from '../../../state';

export const ANIMATION_DURATION = 700;

const useStyles = makeStyles({
  iconContainer: {
    position: 'relative',
    display: 'flex',
    '& path': {
      fill: 'rgb(40, 42, 43)',
    },
  },
  circle: {
    width: '10px',
    height: '10px',
    backgroundColor: '#5BB75B',
    borderRadius: '50%',
    position: 'absolute',
    top: '-3px',
    left: '13px',
    opacity: 0,
    transition: `opacity ${ANIMATION_DURATION * 0.5}ms ease-in`,
  },
  hasUnreadMessages: {
    opacity: 1,
  },
  ring: {
    border: '3px solid #5BB75B',
    borderRadius: '30px',
    height: '14px',
    width: '14px',
    position: 'absolute',
    left: '11px',
    top: '-5px',
    opacity: 0,
  },
  animateRing: {
    animation: `$expand ${ANIMATION_DURATION}ms ease-out`,
    animationIterationCount: 1,
  },
  '@keyframes expand': {
    '0%': {
      transform: 'scale(0.1, 0.1)',
      opacity: 0,
    },
    '50%': {
      opacity: 1,
    },
    '100%': {
      transform: 'scale(1.4, 1.4)',
      opacity: 0,
    },
  },
});

export default function RaiseHandButton() {
  const classes = useStyles();
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const { room } = useVideoContext();
  const { isRaisedHand, setIsRaisedHand } = useAppState();
  const [timeoutId, setTimeoutId] = useState<any>();

  const handleClick = () => {
    setIsRaisedHand(!isRaisedHand);
  };

  useEffect(() => {
    if (shouldAnimate) {
      setTimeout(() => setShouldAnimate(false), ANIMATION_DURATION);
    }
  }, [shouldAnimate]);

  useEffect(() => {
    const dataTracks = Array.from(room?.localParticipant?.dataTracks.values() ?? []) as LocalDataTrackPublication[];
    dataTracks.forEach(pub => {
      pub?.track.send(
        JSON.stringify({
          type: 'raise-hand',
          value: isRaisedHand,
          participantSid: room?.localParticipant?.sid,
        })
      );
    });
  }, [isRaisedHand]);

  useEffect(() => {
    if (isRaisedHand) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      setTimeoutId(
        setTimeout(() => {
          setIsRaisedHand(false);
        }, 30 * 1000)
      );
    }
  }, [isRaisedHand]);

  return (
    <Tooltip title="Jelentkezés">
      <Button onClick={handleClick} variant={isRaisedHand ? 'contained' : 'text'}>
        <div className={classes.iconContainer}>
          <RaiseHandIcon />
        </div>
      </Button>
    </Tooltip>
  );
}
